<template>
  <el-dialog
    class="field-dialog"
    title="字段管理"
    :visible.sync="fieldVisible"
    width="60%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="handleClose">
    <el-dialog
      class="add-dialog"
      width="50%"
      title="新增字段"
      :visible.sync="addVisible"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleCloseAdd">
      <div class="form-container">
        <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px" :inline="true">
          <el-form-item label="字段名称" prop="fieldName" v-if="form.type !== 1">
            <el-input
              v-model="form.fieldName"
              placeholder="请输入字段名称"
              maxLength="20">
            </el-input>
          </el-form-item>
          <el-form-item label="是否为必填" prop="isRequire" v-if="form.type !== 1">
            <el-select v-model="form.isRequire">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否前台展示" prop="isShow">
            <el-select v-model="form.isShow">
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdd">取 消</el-button>
        <el-button @click="submit('ruleForm')">确 认</el-button>
      </span>
    </el-dialog>
    <div class="table-container">
      <el-button class="add" type="primary" @click="addVisible = true">新建</el-button>
      <field-table
        :listen-height="false"
        :refresh="tableInfo.refresh"
        :data.sync="tableInfo.data"
        :query="tableInfo.query"
        :pager="false"
        :total="tableInfo.total"
        :field-list="tableInfo.fieldList"
        :handle="tableInfo.handle"
        :row-class-name="tableRowClassName"
        @handleClick="handleClick"
        @handleEvent="handleEvent"
      >
        <!-- 自定义列表内容 -->
        <template v-slot:col-id="scope">
          <el-input
            v-if="id === scope.row.id && scope.row.id > 1 && showInput"
            v-model="scope.row.sortNum"
            @blur="submitId(scope.row)"
            ></el-input>
          <p v-else @click="handleShowInput(scope.row.sortNum, scope.row.id)">{{ scope.row.sortNum }}</p>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-status="scope">
          <p>{{ scope.row.status === 1 ? '已启用' : '已停用' }}</p>
        </template>
        <!-- 自定义列表内容 -->
        <template v-slot:col-isRequire="scope">
          <p>{{ scope.row.isRequire === 1 ? '是' : '否' }}</p>
        </template>
        <template v-slot:col-isShow="scope">
          <p>{{ scope.row.isShow === 1 ? '是' : '否' }}</p>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-status="scope">
          <el-button
            v-if="scope.data.row.id > 1 && scope.data.row.type !== 1"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.row.status === 1 ? '停用' : '启用' }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-delete="scope">
          <el-button
            v-if="scope.data.row.status === 2 && scope.data.row.id > 1"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
        <!-- 自定义插槽状态按钮 -->
        <template v-slot:bt-edit="scope">
          <el-button
            v-if="scope.data.row.id > 1"
            :type="'text'"
            @click="handleClick(scope.data.item.event, scope.data.row)"
          >
            {{ scope.data.item.label }}
          </el-button>
        </template>
      </field-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import FieldTable from '@/components/PublicTable';
import { addOrganizationField, updateSortNum, fieldStatus, updateOrganizationField, delOrganizationField } from '@/api/api';
export default {
  components: {
    FieldTable
  },
  props: {
    fieldVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      addVisible: false,
      showInput: false,
      id: '',
      tableInfo: {
        refresh: 1,
        initTable: false,
        data: [],
        query: {},
        total: 0,
        fieldList: [
          { label: '字段名称', value: 'fieldName'},
          { label: '排序号', value: 'id', type: 'slot' },
          { label: '是否为必填', value: 'isRequire', type: 'slot'},
          { label: '是否前台展示', value: 'isShow', type: 'slot'},
          { label: '状态', value: 'status', type: 'slot' }
        ],
        handle: {
          label: '操作',
          btList: [
            { label: '删除', type: 'text', event: 'delete', show: true, slot: true },
            { label: '启用', type: 'text', event: 'status', show: true, slot: true },
            { label: '编辑', type: 'text', event: 'edit', show: true, slot: true },
          ]
        }
      },
      form: {
        fieldName: '',
        isRequire: '2',
        isShow: '1'
      },
      rules: {
        fieldName: [
          { required: true, message: '字段不能为空', trigger: 'blur' },
        ],
        isRequire: [
          { required: true, message: '是否为必填不能为空', trigger: 'change' },
        ]
      }
    }
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (rowIndex < 1) {
      return 'warning-row';
      }
      return '';
    },
    init(data) {
      this.tableInfo.data = data.records;
      this.tableInfo.total = Number(data.total);
    },
    // 修改排序号
    submitId(row) {
      if (row.sortNum <= 2) {
        this.$message.error('修改失败');
        return;
      }
      updateSortNum({
        id: row.id,
        sortNum: row.sortNum
      }).then(res => {
        let { code, message } = res;
        if (code === 0) {
          this.$message.success('修改成功');
          this.showInput = false;
          this.$emit('refresh');
        } else {
          this.$message.error(message);
        }
      })
    },
    handleShowInput(sortNum, id) {
      this.sortNum = sortNum;
      this.id = id;
      this.showInput = true;
    },
    // 提交表单
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.id) {
            updateOrganizationField(this.form).then(res => {
              let { code, message } = res;
              if (code === 0) {
                this.$message.success('保存成功');
                this.handleCloseAdd()
                this.$emit('refresh');
              } else {
                this.$message.error(message);
              }
            })
          } else {
            addOrganizationField(this.form).then(res => {
              let { code, message } = res;
              if (code === 0) {
                this.$message.success('保存成功');
                this.handleCloseAdd()
                this.$emit('refresh');
              } else {
                this.$message.error(message);
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 关闭内层弹窗
    handleCloseAdd() {
      this.addVisible = false;
      this.form = {
        fieldName: '',
        isRequire: '2',
        isShow: '1'
      }
    },
    // 关闭外层弹窗
    handleClose() {
      this.$emit('close');
    },
    // table操作
    handleClick(event, row) {
      if (event === 'status') {
        fieldStatus({
          id: row.id,
          status: row.status === 1 ? 2 : 1
        }).then(res => {
          let { code, message } = res;
          if (code === 0) {
            this.$message.success(row.status === 1 ? '发布成功' : '停用成功');
            this.$emit('refresh');
          } else {
            this.$message.error(message);
          }
        })
      } else if (event === 'delete') {
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delOrganizationField({
            id: row.id
          }).then(res => {
            let { code, message } = res;
            if (code === 0) {
              this.$message.success('删除成功');
              this.$emit('refresh');
            } else {
              this.$message.error(message);
            }
          })
        });
      } else {
        this.addVisible = true;
        this.form = {
          id: row.id,
          fieldName: row.fieldName,
          isRequire: String(row.isRequire),
          isShow: String(row.isShow),
          type: row.type
        };
      }
    },
    // table数据
    handleEvent(data) {
      this.tableInfo.data = data.records;
    },
  },
}
</script>

<style lang="scss" scoped>
  .field-dialog {
    ::v-deep .el-dialog{
      .el-dialog__header {
        // background-color: #909399;
        padding: 10px;
        .el-dialog__title {
          font-size: 15px;
          // color: #fff;
        }
        .el-dialog__headerbtn {
          top: 10px;
          i {
            // color: #fff;
          }
        }
      }
      .el-dialog__body {
        max-height: 500px;
        overflow-y: scroll;
        .add {
          margin-bottom: 20px;
        }
        .el-table {
          .warning-row {
            background-color: #F5F7FA;
          }
        }
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
  .add-dialog {
    ::v-deep .el-dialog{
      .el-dialog__header {
        // background-color: #909399;
        padding: 10px;
        .el-dialog__title {
          font-size: 15px;
          // color: #fff;
        }
        .el-dialog__headerbtn {
          top: 10px;
          i {
            // color: #fff;
          }
        }
      }
      .el-dialog__body {
        max-height: 500px;
        overflow-y: scroll;
      }
      .el-dialog__footer {
        width: 100%;
        border-top: 1px solid #ddd;
        padding-top: 15px;
      }
    }
  }
</style>